module.exports = __webpack_public_path__ + "img/rope_customer-specific_8.e26e4ae3.jpg";